import { GoogleLogin } from "@react-oauth/google";
import { FcGoogle } from "react-icons/fc";
import { toast } from 'react-hot-toast'; // or any toast library

export function GoogleAuthButton({ onSuccess }: { onSuccess: (token: string) => void }) {

    function handleGoogleLoginError(_error: unknown) {
        toast.error("Google login failed. Please try again.");
    }
    return (
        <>
            <div id="google-login-hidden" className="hidden">
                <GoogleLogin
                    onSuccess={(credentialResponse) => {
                        if (!credentialResponse.credential) return;
                        onSuccess(credentialResponse.credential);
                    }}
                    onError={() => handleGoogleLoginError}
                    useOneTap={false}
                    type="standard"
                    size="large"
                />
            </div>

            <button
                type="button"
                onClick={() => {
                    const realBtn = document.querySelector<HTMLDivElement>(
                        "#google-login-hidden div[role=button]"
                    );
                    realBtn?.click();
                }}
                className="w-12 h-12 flex items-center justify-center rounded-full
             border border-border shadow-sm hover:bg-muted transition
             focus:outline-none focus:ring-0 active:outline-none"
            >
                <FcGoogle size={22} />
            </button>
        </>
    );
}
